// Norvig — Sectors (English overlays)
// Used by useSectors() in sectors.js. Same shape as SECTORS, only translatable strings.

export const SECTOR_CATEGORIES_EN = {
  public:  { id: 'public',  label: 'Public sector',  short: 'Public' },
  private: { id: 'private', label: 'Private sector', short: 'Private' },
};

export const SECTORS_EN = {
  health: {
    label: 'Health & care',
    short: 'Health',
    tagline: 'Talent that cares.',
    description:
      'Registered nurses, health care workers, doctors and physiotherapists for municipalities and hospitals across Norway.',
    longDescription:
      'Norway’s health service needs qualified hands. We match skilled workers with direct authorisation or an approval pathway through the Norwegian Directorate of Health, and help with visa, housing and integration.',
    professions: [
      { id: 'sykepleier',       label: 'Registered nurse' },
      { id: 'helsefagarbeider', label: 'Health care worker' },
      { id: 'lege',             label: 'Doctor' },
      { id: 'fysioterapeut',    label: 'Physiotherapist' },
      { id: 'jordmor',          label: 'Midwife' },
      { id: 'ergoterapeut',     label: 'Occupational therapist' },
      { id: 'vernepleier',      label: 'Social educator' },
    ],
    benefits: [
      'Authorisation via the Directorate of Health',
      'Collective agreements and pension schemes',
      'Opportunities for specialisation',
    ],
  },
  oppvekst: {
    label: 'Education',
    short: 'Education',
    tagline: 'Educators shaping the future.',
    description:
      'Preschool teachers, teachers and support workers for public institutions.',
    longDescription:
      'Norwegian kindergartens and schools need qualified educators. We help with recognition of education, Norwegian language training and the transition into Norwegian pedagogical life.',
    professions: [
      { id: 'barnehagelaerer', label: 'Preschool teacher' },
      { id: 'laerer',          label: 'Teacher' },
      { id: 'pedagog',         label: 'Educator' },
      { id: 'miljoarbeider',   label: 'Support worker' },
      { id: 'spesialpedagog',  label: 'Special needs educator' },
    ],
    benefits: [
      'Recognition of education by the Directorate',
      'Pension schemes via SPK',
      'Long holidays and family-friendly working hours',
    ],
  },
  sesong: {
    label: 'Seasonal work',
    short: 'Seasonal',
    tagline: 'Strong hands for Norwegian nature.',
    description:
      'Fruit, berry and tourism workers for peak seasons across Norway.',
    longDescription:
      'Norway offers well-paid seasonal work in fruit and berry production, horticulture and tourism. Short engagements (3–6 months) with housing and tariff, perfect for building a network and exploring the country. If you thrive in Norway, you have every opportunity to build a future here. Norwegian employers in the fruit, berry and tourism industries need motivated, engaged and skilled workers. Your effort is valued!',
    professions: [
      { id: 'gartner',              label: 'Gardener' },
      { id: 'reiselivsmedarbeider', label: 'Tourism worker' },
      { id: 'sesongarbeider',       label: 'Seasonal worker' },
      { id: 'baerplukker',          label: 'Berry picker' },
    ],
    benefits: [
      'Housing usually included',
      'Collective agreements and overtime pay',
      'Opportunity to return each season',
    ],
  },
};
